import { del } from "../methods";
function deleteCoupon(headers = {}) {
  return del({
    url: "customer/discount/delete",
    baseURL: "https://billing.simplywall.st/",
    headers
  });
}
export {
  deleteCoupon as default
};
